__turbopack_context__.v({
  "content": "account-compact-module-sass-module__nRIDVW__content",
  "header": "account-compact-module-sass-module__nRIDVW__header",
  "menu": "account-compact-module-sass-module__nRIDVW__menu",
  "menuItem": "account-compact-module-sass-module__nRIDVW__menuItem",
  "messagesBtn": "account-compact-module-sass-module__nRIDVW__messagesBtn",
  "selected": "account-compact-module-sass-module__nRIDVW__selected",
  "signOutBtn": "account-compact-module-sass-module__nRIDVW__signOutBtn",
  "unreadMsgsCount": "account-compact-module-sass-module__nRIDVW__unreadMsgsCount",
  "userId": "account-compact-module-sass-module__nRIDVW__userId",
  "userInfo": "account-compact-module-sass-module__nRIDVW__userInfo",
});
